import React, { useRef, useState } from 'react';
import ENUMS from '../../enums';

const TicketsFilter = props => {
  let formRefrence = useRef();
  let [creatorFullNamePart, setCreatorFullNamePart] = useState('');
  let [titlePart, setTitlePart] = useState('');
  let [clientMessagePart, setClientMessagePart] = useState('');

  let statusList = ENUMS.TICKETS_STATUS.list;
  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCreatorFullNamePart('');
    setTitlePart('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex col-12 justify-content-start p-0 align-items-center">
            <div className="col-12">
              <label className="col-12 p-0 text-right">{locales('tables.status')} :</label>
              <div className="d-flex justify-content-between mx-1 py-2">
                <div className="col-12 p-0 d-flex justify-content-start align-items-center">
                  {statusList.map((ticket, index) => (
                    <div className={`col-3 d-flex justify-content-start align-items-center p-0`} key={index}>
                      <input
                        type="checkbox"
                        value={ticket.value}
                        name={`status`}
                        id={`status-${index}`}
                        className="col-4"
                      />
                      <label className="mx-1 text-center my-2 p-0" htmlFor={`status-${index}`}>
                        {ticket.title}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justidy-content-between px-1">
            <div className="d-flex flex-column mx-1 col-4 h-50 py-2">
              <input
                onChange={event => setCreatorFullNamePart(event.target.value)}
                value={creatorFullNamePart || ''}
                name="creatorFullNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('titles.creatorName')}
                maxLength={ENUMS.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
            <div className="d-flex flex-column mx-1 col-4 h-50 py-2">
              <input
                onChange={event => setTitlePart(event.target.value)}
                value={titlePart || ''}
                name="titlePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.title')}
                maxLength={ENUMS.MAX_LENGTH.ticketTitle}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.100')}</small>
            </div>
            <div className="d-flex flex-column mx-1 col-4 h-50 py-2">
              <input
                onChange={event => setClientMessagePart(event.target.value)}
                value={clientMessagePart || ''}
                name="clientMessagePart"
                type="text"
                className="form-control col-12"
                placeholder="متن پیام"
              />
              <small style={{ color: '#ccc' }}>برای جست و جو بخشی از متن تیکت را وارد کنید</small>
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-tickets" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default TicketsFilter;
